import React from 'react'
import { Grid2, Typography, DialogTitle } from '@mui/material'
import { styled } from '@mui/material/styles'
import { IconCloseButton } from 'asterX-UI/Buttons'
import PropTypes from 'prop-types'

const ModalTitleRoot = styled(DialogTitle)(({ theme }) => ({
  margin: 0,
  position: 'relative',
  padding: '15px 20px 10px 20px',
  display: 'flex',
  flexDirection: 'column'
}))

const IconContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row'
})

const Title = styled(Typography)({
  fontWeight: 600
})

const ModalTitleIconed = ({ children, onClose, disableBtn = false, iconComponent, subtitle, ...other }) => {
  const justifyContent = () => {
    if (!!iconComponent && !!onClose && !disableBtn) {
      return 'space-between'
    } else if (!!iconComponent && (disableBtn || !onClose)) {
      return 'flex-start'
    } else {
      return 'flex-end'
    }
  }

  return (
    <ModalTitleRoot {...other}>
      <Grid2
        container
        sx={{
          display: 'flex',
          direction: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'nowrap',
          width: '100%'
        }}
      >
        <Grid2>
          <Title variant="subtitle1" sx={{ fontWeight: 700 }}>
            {children}
          </Title>
        </Grid2>
        <Grid2>
          <IconContainer sx={{ justifyContent }}>
            {!!iconComponent && <div>{iconComponent}</div>}
            {onClose && !disableBtn && <IconCloseButton aria-label="close" onClick={onClose} />}
          </IconContainer>
        </Grid2>
      </Grid2>
      {!!subtitle && (
        <Grid2 size={{ xs: 12 }}>
          <Typography sx={{ fontSize: '14px' }} color="textSecondary">
            {subtitle}
          </Typography>
        </Grid2>
      )}
    </ModalTitleRoot>
  )
}

ModalTitleIconed.propTypes = {
  onClose: PropTypes.func,
  iconComponent: PropTypes.node,
  children: PropTypes.any,
  disableBtn: PropTypes.bool,
  subtitle: PropTypes.string
}

export default ModalTitleIconed
